import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { MARIGOLD_DARK } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LargerIconCircle = styled(UIIconCircle).withConfig({
  displayName: "CheckedListItem__LargerIconCircle",
  componentId: "sc-7j9x5o-0"
})(["padding:0.25em;& [data-icon-name]{font-size:1.75em !important;}"]);
const CheckedListItem = _ref => {
  let {
      children
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(UIFlex, Object.assign({
    className: "m-bottom-4"
  }, otherProps, {
    children: [/*#__PURE__*/_jsx(LargerIconCircle, {
      className: "m-right-4 checked-list-icon",
      color: MARIGOLD_DARK,
      name: "success",
      size: 10
    }), children]
  }));
};
export default CheckedListItem;